import name from './name'

const selectSliceData = state => state[name]

const selectShowDialog = state => selectSliceData(state).showDialog

export { selectShowDialog }
